const RECENT_PAGE_MIN = 0;
const RECENT_PAGE_MAX = 20;
const RECENT_ENTITY_MAX = 3;
const NAME_LENGTH = 20;
const KEY = "recentPages";

const storeRecent = {
    namespaced: true,
    state: {
        _pages: [],
        _userId: null,
        _routeHistory: []
    },
    getters: {
        recentPages: state => {
          const MAX = 5;
          const TOTAL = 10;
          let ers = state._pages.filter(x => x.type == 'employer');
          let pts = state._pages.filter(x => x.type == 'participant');

          if(ers.length <= MAX) return [...ers, ...pts.slice(0, TOTAL - ers.length)];
          else if(pts.length <= MAX) return [...ers.slice(0, TOTAL - pts.length), ...pts];
          else return [...ers.slice(0, MAX), ...pts.slice(0, MAX)];
        },
        recentParticipants: state => id => {
          return state._pages.filter(x => x.employerId == id).slice(RECENT_PAGE_MIN, RECENT_ENTITY_MAX);
        },
        recentEmployers: state => {
          return state._pages.filter(x => x.type == 'employer').slice(RECENT_PAGE_MIN, RECENT_ENTITY_MAX);
        },
        routeHistory: state => state._routeHistory
    },
    actions: {
        load({commit}, userId) {
            // console.log("x-recent load userId: ", userId);
            if(!userId) throw "User Id is required to load recent store!";
            commit("loadPages", userId);
        },
        addPage({commit}, data) {
            // console.log("x-recent addPage data: ", data);
            if(!data.userId)
                throw "User Id is required to addPage to recent store!";
            if(!data.name || !data.route) 
                throw "Name, Route params are required in recent store!";
            if(data.name.length > NAME_LENGTH)
                data.name = data.name.slice(0, NAME_LENGTH) + '...';
            if(data.route[0] == '/') 
                data.route = data.route.slice(1);
            let routeTokens = data.route.split('/');
            data.type = routeTokens[0];
            data.id = routeTokens[1];
            if(data.type == "participant" && !data.employerId) 
                throw "Participant links must include an employerId in the recent store!"
            commit("loadPages", data.userId);
            commit("addToPages", data);
        },
        addToHistory({commit}, data) {
            commit("addToHistory", data);
        }
    },
    mutations: {
        loadPages(state, userId){
            if(state._userId != userId || !state._pages || state._pages.length <= 0) {
                let data = localStorage.getItem(KEY + userId);
                state._userId = userId;
                state._pages = data ? JSON.parse(data) : [];
                // console.log("x-recent loadPages pages: ", state._userId, state._pages);
            }
        },
        addToHistory(state, data) {
            state._routeHistory.push(data.route.path);
        },
        addToPages(state, data) {
            state._pages = [ data, ...state._pages.filter(x => x.id != data.id)]
                .slice(0, RECENT_PAGE_MAX);
            localStorage.setItem(KEY + data.userId, JSON.stringify(state._pages));
            // console.log("x-recent addPages pages: ", state._userId, state._pages);
        },
    },
}

export default storeRecent;



// WEBPACK FOOTER //
// ./src/framework/utils/x-recent.js